import { useEffect } from 'react'
import { useUpdate } from 'react-use'

interface Args {
  getMenuExpandedStatus: () => boolean
}

/**
 * Observe the aria-expanded attribute of the nav drawer to trigger a re-render when it changes,
 * to set the button aria-expanded attribute correctly.
 * @param param0
 * @returns {boolean}
 */
export const useObserveAriaExpandedNav = ({ getMenuExpandedStatus }: Args) => {
  const update = useUpdate()

  useEffect(() => {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          update()
        }
      }
    })

    const targetNode = document.getElementById('page-with-nav-drawer')

    if (targetNode) {
      observer.observe(targetNode, { attributes: true })

      // Clean up observer on unmount
      return () => {
        observer.disconnect()
      }
    }
  }, [])

  const ariaExpandedValue = getMenuExpandedStatus()

  return ariaExpandedValue
}
